import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CellContent, TableColumnMetadata, TableRow } from 'src/app/table-handling/types';
import { getCellContentLabel } from 'src/app/table-handling/util';

import iconLibrary from 'src/app/common/iconLibrary';
import { ActionDirective, AlerterDirective, CellStylesDirective, ContentDirective } from '../directives';
import { GenericTableCellComponent } from '../generic-table-cell/generic-table-cell.component';
import { CellValuePipe } from '../pipes';
import { CellActionPipe } from '../pipes/cell-action.pipe';
import { TableCellLinebreakComponent } from '../table-cell-linebreak/table-cell-linebreak.component';

@Component({
  selector: 'app-table-cell',
  standalone: true,
  imports: [
    CommonModule,
    CellValuePipe,
    CellActionPipe,
    AlerterDirective,
    CellStylesDirective,
    ContentDirective,
    ActionDirective,
    TableCellLinebreakComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss'],
})
export class TableCellComponent extends GenericTableCellComponent implements OnChanges {
  @Input() public data: CellContent;
  @Input() public meta: TableColumnMetadata | null;
  @Input() public row: TableRow;

  protected readonly iconLibrary: string = iconLibrary;

  public ngOnChanges({ data }: SimpleChanges): void {
    if (!data) {
      return;
    }

    this.build();
  }

  protected override getValue(): string | number {
    return getCellContentLabel(this.data);
  }
}
